import { render, staticRenderFns } from "./AupairSponsorDetails.vue?vue&type=template&id=4a7a9115&"
import script from "./AupairSponsorDetails.vue?vue&type=script&lang=js&"
export * from "./AupairSponsorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports